







































































































































































import { Component, Prop, Mixins } from "vue-property-decorator";
import * as fabric from "@/models/products/fabric";
import { Mobile } from "@/mixins/mobile";
import { FabricComponent } from "@/models/configurator/fabric_components";

@Component
export default class FabricFilter extends Mixins(Mobile) {
  /**
   * For filtering purposes, all filters are case sensitive to their match to what is returned by API
   * Only change to match how these values are being returned by API
   */
  @Prop() isStockOnly!: boolean;
  @Prop() filters!: fabric.FabricFilter;
  @Prop({ default: false }) solidsOnly!: boolean;
  @Prop({ default: false }) noStripes!: boolean;
  @Prop({ default: false }) gradeAOnly!: boolean;
  @Prop({ default: false }) isFringeComponent!: boolean;
  @Prop({ default: false }) isBindingComponent!: boolean;
  @Prop() mainFabricWeight!: string;
  @Prop({ default: null }) component!: FabricComponent | null;
  @Prop({ default: () => new Set() }) availableGrades!: Set<string>;
  @Prop({ default: () => new Set() }) availableColors!: Set<string>;
  @Prop({ default: () => new Set() }) availableDesigns!: Set<string>;
  @Prop({ default: () => new Set() }) availableBrands!: Set<string>;
  @Prop({ default: () => new Set() }) availableWeights!: Set<string>;
  // "a/ap" is a virtual entry that selects both real grades A and A+.
  protected grades: string[] = [
    "a/ap",
    "a",
    "ap",
    "b",
    "c",
    "d",
    "e",
    "f",
    "fp"
  ];
  protected colors: string[] = [
    "Beige",
    "Black",
    "Blue",
    "Brown",
    "Gold",
    "Grey",
    "Green",
    "Ivory",
    "Orange",
    "Pink",
    "Purple",
    "Red",
    "Turquoise",
    "White",
    "Yellow"
  ];
  protected designs: string[] = [
    "Solids",
    "Stripes",
    "Textures",
    "Geometrics",
    "Tweeds"
  ];
  /**
   * Brand entries follow shade-designer's shape: `mfr` is the
   * manufacturer; `brand` (optional) is the sub-brand. The template
   * renders "<mfr>® / <brand>®" when both are present, with the ® on
   * the manufacturer suppressed when a sub-brand exists. SENS is the
   * one exception that doesn't carry a ® on the sub-brand.
   */
  protected brands: { handle: string; mfr: string; brand?: string }[] = [
    { handle: "recacril", mfr: "Recasens", brand: "Recacril" },
    { handle: "sens", mfr: "Recasens", brand: "SENS" },
    { handle: "outdura", mfr: "Sattler", brand: "Outdura" },
    { handle: "sunbrella", mfr: "Sunbrella" },
    { handle: "tempotest", mfr: "Tempotest" }
  ];
  protected weights: string[] = ["8", "9"];
  protected fabricTypes: { label: string; value: string }[] = [
    { label: "Polycotton", value: "polycotton" },
    { label: "Acrylic", value: "acrylic" }
  ];

  get isNotSpecialFabricComponent(): boolean {
    if (
      this.component !== FabricComponent.Main &&
      this.component !== FabricComponent.Binding &&
      this.component !== FabricComponent.Underside
    ) {
      return true;
    } else {
      return false;
    }
  }

  public makeSentenceCase(sentence: string) {
    return sentence.charAt(0).toUpperCase() + sentence.slice(1);
  }

  protected gradeLabel(grade: string): string {
    if (grade === "a/ap") return "Grades A/A+";
    if (grade === "ap") return "Grade A+";
    if (grade === "fp") return "Grade F+";
    return "Grade " + this.makeSentenceCase(grade);
  }

  /**
   * "a/ap" is the virtual combined filter — selected when the filters
   * array contains both "a" and "ap".
   */
  protected isGradeSelected(grade: string): boolean {
    const arr = this.filters.grade;
    if (!arr) return false;
    if (grade === "a/ap") {
      return arr.includes("a") && arr.includes("ap");
    }
    return arr.length === 1 && arr[0] === grade;
  }

  /**
   * Available if either real grade has any fabric in the eligible pool —
   * "a/ap" is shown when either "a" OR "ap" has fabrics available.
   */
  protected isGradeAvailable(grade: string): boolean {
    if (grade === "a/ap") {
      return this.availableGrades.has("a") || this.availableGrades.has("ap");
    }
    return this.availableGrades.has(grade);
  }

  protected highlightColor(color: string): boolean {
    let highlight = false;
    if (this.filters.color.length > 0 && this.filters.color.includes(color)) {
      highlight = true;
    }
    return highlight;
  }

  /** The following set####()methods communicate user selected filters to the fabric swatch display (FabricSelector.vue) */
  protected setGrade(value: string): void {
    this.$emit("setGrade", value);
  }

  /** Color filters are additive, whilst other filters are just one at a time */
  protected setColor(value: string): void {
    const colorArray =
      this.filters.color.length > 0 ? [...this.filters.color] : [];
    if (!value) {
      this.$emit("setColor", []);
    } else if (this.filters.color.includes(value)) {
      const newColors = colorArray.filter(color => color !== value);
      this.$emit("setColor", newColors);
    } else {
      colorArray.push(value);
      this.$emit("setColor", colorArray);
    }
  }

  protected setDesign(value: string): void {
    this.$emit("setDesign", value);
  }

  protected setBrand(value: string): void {
    this.$emit("setBrand", value);
  }

  protected setWeight(value: string): void {
    this.$emit("setWeight", value);
  }

  protected setFabricType(value: string): void {
    this.$emit("setFabricType", value);
  }
}
